import React from "react";
import useTranslate from "../truebar/contexts/Translate/TranslateContext";
import { Languages } from "../truebar/contexts/Translate/types";
import DownloadSection, { IVersions } from "../DownloadSection";

const CLIENTS_TERMS_OF_USE_FILE_PATH_PREFIX = "./files/terms_of_use_clients/"
const versions: IVersions[] = [
    {
        englishFileName: 'TERMS AND CONDITIONS FOR USE OF TRUEBAR SERVICE FOR CLIENTS_v1.2.pdf',
        slovenianFileName: 'DOLOČILA IN POGOJI UPORABE STORITVE TRUEBAR ZA NAROČNIIKE_v1.2.pdf'
    },
    {
        englishFileName: 'TERMS AND CONDITIONS FOR USE OF TRUEBAR SERVICE FOR CLIENTS_v1.1.pdf',
        slovenianFileName: 'DOLOČILA IN POGOJI UPORABE STORITVE TRUEBAR ZA NAROČNIIKE_v1.1.pdf'
    }
]

const ClientsTermsOfUse = () => {

    const {
        selectedLanguage,
        changeLanguage
    } = useTranslate()

    const currentVersionFileName = selectedLanguage === Languages.si ? versions[0].slovenianFileName : versions[0].englishFileName

    return (
        <>
            <div style={{ float: 'right', paddingTop: '2vh', paddingRight: '5vw' }}>
                <button style={{ color: 'white' }} onClick={() => changeLanguage()}>
                    {selectedLanguage === Languages.si ? 'EN' : 'SI'}
                </button>
            </div>

            <div style={{ padding: '0 10vw' }}>
                <h1 style={{ textAlign: 'center', margin: '5vh 0' }}>{selectedLanguage === Languages.si ? 'Pogoji uporabe za naročnike' : 'Terms of use for Clients'}</h1>
                <h2 style={{ margin: '10vh 0 5vh 0' }}>{selectedLanguage === Languages.si ? 'Trenutna verzija' : 'Current version'}</h2>
                <DownloadSection versionName={currentVersionFileName} filePathPrefix={CLIENTS_TERMS_OF_USE_FILE_PATH_PREFIX} />

                {versions.length > 1 && (
                    <>
                        <h2 style={{ margin: '10vh 0 5vh 0' }}>{selectedLanguage === Languages.si ? 'Zgodovin verzij' : 'Version history'}</h2>
                        {versions.slice(1).map(version => {
                            const historyVersionFileName = selectedLanguage === Languages.si ? version.slovenianFileName : version.englishFileName
                            return <DownloadSection versionName={historyVersionFileName} filePathPrefix={CLIENTS_TERMS_OF_USE_FILE_PATH_PREFIX} />
                        })}
                    </>
                )}
            </div>
        </>
    )
}

export default ClientsTermsOfUse;